export const KEY_REDUCER_SHOP = "shop";
export const LOADER_ID_SHOP = "shop/loader";
